import * as _ from 'lodash';
import moment from 'moment';

import { Item } from 'fc-ui-components';

import { getFileType } from 'helpers';

import { MarketingFileSeason } from './metadata-ui-mapper';

export class FiltersProvider {
    constructor() {}

    public isInFilters(filterValue: string | MarketingFileSeason, filter: Item[]): boolean {
        if (_.isEmpty(filter)) {
            return false;
        }
        return _.findIndex(filter, ({ value }) => _.isEqual(value, filterValue)) > -1;
    }

    public fileIsShownByFilters(file, filters: Filters): boolean {
        const seasonIsOnFilters =
            _.isEmpty(filters[FilterType.Season]) || this.isFileSeasonInFilters(file, filters[FilterType.Season]);
        const channelIsOnFilters =
            _.isEmpty(filters[FilterType.Channel]) || this.isFileChannelInFilters(file, filters[FilterType.Channel]);
        const fileTypeIsOnFilters =
            _.isEmpty(filters[FilterType.FileType]) || this.isFileTypeInFilters(file, filters[FilterType.FileType]);
        const expirationDateOnFilters =
            _.isEmpty(filters[FilterType.ExpirationDate]) ||
            this.isFileExpirationDateInFilters(file, filters[FilterType.ExpirationDate][0]);

        const searchInputOnFilters =
            _.isEmpty(filters[FilterType.SearchInput]) ||
            this.isFileSearchInputInFilters(file, filters[FilterType.SearchInput]);

        return (
            seasonIsOnFilters &&
            channelIsOnFilters &&
            fileTypeIsOnFilters &&
            expirationDateOnFilters &&
            searchInputOnFilters
        );
    }

    private isFileSeasonInFilters(file, filters: Item[]) {
        const season = {
            season: file.metadata.season,
            year: file.metadata.year ? file.metadata.year : null
        };

        return this.isInFilters(season, filters);
    }

    private isFileChannelInFilters(file, filters: Item[]) {
        const fileChannels = file.metadata.channels;

        return !_.isEmpty(_.intersection(fileChannels, _.map(filters, 'value')));
    }

    private isFileTypeInFilters(file, filters: Item[]) {
        const fileType = getFileType(file.files[0].file.extension);

        return _.includes(_.map(filters, 'value'), fileType);
    }

    private isFileSearchInputInFilters(file, filters: Item[]) {
        const checkSearchInputIntersection = (fileSearchInput, filterSearchInput) =>
            new RegExp(filterSearchInput, 'i').test(fileSearchInput);

        const isFileInFilter = (field, filters: Item[]) =>
            !_.isEmpty(_.intersectionWith(field, _.map(filters, 'value'), checkSearchInputIntersection));

        const isFileArticleNumberInFilters = isFileInFilter(file.metadata.articleNumbers, filters);
        if (isFileArticleNumberInFilters) return true;

        const isFileNameInFilters = isFileInFilter(_.map(file.files, 'file.name'), filters);
        if (isFileNameInFilters) return true;

        const isTagInFilters = isFileInFilter(file.metadata.tags, filters);
        return isTagInFilters;
    }

    private isFileExpirationDateInFilters(file, filters: Item) {
        if (filters.value === 'ALL') {
            return true;
        }

        return moment(file.metadata.expirationDate).isSameOrAfter(filters.value);
    }
}

export enum FilterType {
    Season = 'seasons',
    Channel = 'channels',
    FileType = 'fileTypes',
    ExpirationDate = 'expirationDates',
    SearchInput = 'searchInputs'
}

export interface Filters {
    [FilterType.Season]: Item[];
    [FilterType.ExpirationDate]: Item[];
    [FilterType.Channel]: Item[];
    [FilterType.FileType]: Item[];
    [FilterType.SearchInput]: Item[];
}
